import axios from "axios";
import { baseUrl, azilisSwitchToBool } from "../util";

// Flow 45 Totals
export const getDisposal45Totals = ({
  productId,
  setTotals = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url: baseUrl + `/api/business/product/${productId}/disposal-45-totals`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setTotals(response.data.data || null);
    })
    .catch(function (error) {
      console.error("Error fetching disposal 45 totals:", error);
      setTotals(null);
    });
};

// Flow 45.1 - Waste processing - final treatment
export const getAllFlow45_1LCA = ({
  productId,
  setObjects = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url: baseUrl + `/api/business/product/${productId}/flow-45-1-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(response.data.data || []);
    })
    .catch(function (error) {
      console.error("Error fetching flow 45.1:", error);
      setObjects([]);
    });
};

export const addFlow45_1LCA = ({
  productId,
  name_part_in_fu,
  describe_process,
  how_is_part_disposed,
  quantity_per_fu,
  waste_process_scenario,
  collecting_scenario,
  surplus_material_replaces_new_purchase,
  callback,
  use_swal = false,
}) => {
  var config = {
    method: "post",
    url: baseUrl + `/api/business/product/${productId}/flow-45-1-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      name_part_in_fu: name_part_in_fu || null,
      describe_process: describe_process || null,
      how_is_part_disposed: how_is_part_disposed || null,
      quantity_per_fu: quantity_per_fu || 0,
      waste_process_scenario: waste_process_scenario || null,
      collecting_scenario: collecting_scenario || null,
      surplus_material_replaces_new_purchase: azilisSwitchToBool(
        surplus_material_replaces_new_purchase
      ),
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
      if (use_swal) {
        window.swal({
          title: "Success!",
          text: "Flow 45.1 item added successfully",
          icon: "success",
          button: "OK",
        });
      }
    })
    .catch(function (error) {
      console.error("Error adding flow 45.1:", error);
      if (use_swal) {
        window.swal({
          title: "Error!",
          text: error.response?.data?.message || "Failed to add flow 45.1 item",
          icon: "error",
          button: "OK",
        });
      }
    });
};

export const updateFlow45_1LCA = ({
  productId,
  rowId,
  name_part_in_fu,
  describe_process,
  how_is_part_disposed,
  quantity_per_fu,
  waste_process_scenario,
  collecting_scenario,
  surplus_material_replaces_new_purchase,
  objects,
  setObjects,
  use_swal = false,
  callback,
}) => {
  var config = {
    method: "put",
    url: baseUrl + `/api/business/product/${productId}/flow-45-1-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      name_part_in_fu: name_part_in_fu || null,
      describe_process: describe_process || null,
      how_is_part_disposed: how_is_part_disposed || null,
      quantity_per_fu: quantity_per_fu || 0,
      waste_process_scenario: waste_process_scenario || null,
      collecting_scenario: collecting_scenario || null,
      surplus_material_replaces_new_purchase: azilisSwitchToBool(
        surplus_material_replaces_new_purchase
      ),
    },
  };

  axios(config)
    .then(function (response) {
      if (setObjects && objects) {
        const updatedObjects = objects.map((obj) =>
          obj.id === rowId ? { ...obj, ...response.data.data } : obj
        );
        setObjects(updatedObjects);
      }
      if (callback) callback();
      if (use_swal) {
        window.swal({
          title: "Success!",
          text: "Flow 45.1 item updated successfully",
          icon: "success",
          button: "OK",
        });
      }
    })
    .catch(function (error) {
      console.error("Error updating flow 45.1:", error);
      if (use_swal) {
        window.swal({
          title: "Error!",
          text: error.response?.data?.message || "Failed to update flow 45.1 item",
          icon: "error",
          button: "OK",
        });
      }
    });
};

export const deleteFlow45_1LCA = ({ productId, rowId, callback }) => {
  var config = {
    method: "delete",
    url: baseUrl + `/api/business/product/${productId}/flow-45-1-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
      window.swal({
        title: "Success!",
        text: "Flow 45.1 item deleted successfully",
        icon: "success",
        button: "OK",
      });
    })
    .catch(function (error) {
      console.error("Error deleting flow 45.1:", error);
      window.swal({
        title: "Error!",
        text: error.response?.data?.message || "Failed to delete flow 45.1 item",
        icon: "error",
        button: "OK",
      });
    });
};

// Flow 45.2 - Losses for everything in this category
export const getAllFlow45_2LCA = ({
  productId,
  setObjects = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url: baseUrl + `/api/business/product/${productId}/flow-45-2-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(response.data.data || []);
    })
    .catch(function (error) {
      console.error("Error fetching flow 45.2:", error);
      setObjects([]);
    });
};

export const addFlow45_2LCA = ({
  productId,
  own_name,
  material,
  amount,
  callback,
  use_swal = false,
}) => {
  var config = {
    method: "post",
    url: baseUrl + `/api/business/product/${productId}/flow-45-2-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      own_name: own_name || null,
      material: material || null,
      amount: amount || 0,
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
      if (use_swal) {
        window.swal({
          title: "Success!",
          text: "Flow 45.2 item added successfully",
          icon: "success",
          button: "OK",
        });
      }
    })
    .catch(function (error) {
      console.error("Error adding flow 45.2:", error);
      if (use_swal) {
        window.swal({
          title: "Error!",
          text: error.response?.data?.message || "Failed to add flow 45.2 item",
          icon: "error",
          button: "OK",
        });
      }
    });
};

export const updateFlow45_2LCA = ({
  productId,
  rowId,
  own_name,
  material,
  amount,
  objects,
  setObjects,
  use_swal = false,
  callback,
}) => {
  var config = {
    method: "put",
    url: baseUrl + `/api/business/product/${productId}/flow-45-2-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      own_name: own_name || null,
      material: material || null,
      amount: amount || 0,
    },
  };

  axios(config)
    .then(function (response) {
      if (setObjects && objects) {
        const updatedObjects = objects.map((obj) =>
          obj.id === rowId ? { ...obj, ...response.data.data } : obj
        );
        setObjects(updatedObjects);
      }
      if (callback) callback();
      if (use_swal) {
        window.swal({
          title: "Success!",
          text: "Flow 45.2 item updated successfully",
          icon: "success",
          button: "OK",
        });
      }
    })
    .catch(function (error) {
      console.error("Error updating flow 45.2:", error);
      if (use_swal) {
        window.swal({
          title: "Error!",
          text: error.response?.data?.message || "Failed to update flow 45.2 item",
          icon: "error",
          button: "OK",
        });
      }
    });
};

export const deleteFlow45_2LCA = ({ productId, rowId, callback }) => {
  var config = {
    method: "delete",
    url: baseUrl + `/api/business/product/${productId}/flow-45-2-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
      window.swal({
        title: "Success!",
        text: "Flow 45.2 item deleted successfully",
        icon: "success",
        button: "OK",
      });
    })
    .catch(function (error) {
      console.error("Error deleting flow 45.2:", error);
      window.swal({
        title: "Error!",
        text: error.response?.data?.message || "Failed to delete flow 45.2 item",
        icon: "error",
        button: "OK",
      });
    });
};

